import styled from 'styled-components';

export const StyledUserAttributesModal = styled.div`
    display: flex;
    width: 100vw;
    height: 100vh;
    box-sizing: border-box;
    align-items: center;
    padding: 56px;
    gap: 140px;
    background-color: ${(p) => p.theme.colors.background};
`;

export const StyledUserAttributesImage = styled.img`
    width: min(584px, 40%);
    flex: 1;
`;

export const StyledUserAttributesBody = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 40px;
`;

export const StyledUserAttributesContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const StyledUserAttributesItem = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;
